module.exports = __webpack_public_path__ + "static/media/css.5d1cc864.png";